import { AVATAR_BADGE_SIZE, AvatarBasic } from '@npco/zeller-design-system'

import { ReactComponent as SavingsAccountIcon } from 'assets/svg/accounts/savings-account.svg'

import * as styled from './SavingsAccountAvatar.styled'

type SavingsAccountAvatarProps = {
  badgeSize?: AVATAR_BADGE_SIZE
  shouldAnimate?: boolean
  withCursorPointer?: boolean
  grayscale?: boolean
}

export const SavingsAccountAvatar = ({
  badgeSize = AVATAR_BADGE_SIZE.SMALL,
  shouldAnimate = false,
  withCursorPointer = false,
  grayscale = false,
}: SavingsAccountAvatarProps) => {
  return (
    <AvatarBasic
      text=""
      userDefinedContent={
        shouldAnimate ? (
          <styled.AnimatedAvatarSvg data-testid="animated-savings-avatar">
            <SavingsAccountIcon data-testid="savings-avatar" />
          </styled.AnimatedAvatarSvg>
        ) : (
          <SavingsAccountIcon data-testid="savings-avatar" />
        )
      }
      badgeSize={badgeSize}
      withCursorPointer={withCursorPointer}
      grayscale={grayscale}
    />
  )
}
